import { useNavigate, useParams } from "react-router";

import { Chip, Divider, Skeleton, Stack, Typography } from "@mui/material";
import { ArcPlcCropIcon, InfoIcon, WarningIcon } from "components/Icons/Icons";
import { BASE_ACRES_COMMODITY_NAMES_WITH_TYPE } from "components/Vault/Farm/helpers";
import { formatNumber, formatPrice } from "utility/formatters";

import { TilleyCard } from "../../Cards/TilleyCard";

export default function ArcPlcCountyCropCard({ baseAcres, arcPlc, isLoadingArcPlc, isErrorArcPlc }) {
  const navigate = useNavigate();
  const { crop_year, location_state_name, location_county_name } = useParams();

  const shouldShowType = BASE_ACRES_COMMODITY_NAMES_WITH_TYPE.includes(baseAcres?.commodity_name);
  const cardTitle =
    shouldShowType && baseAcres?.type_name
      ? `${baseAcres.commodity_name} - ${baseAcres.type_name}`
      : baseAcres?.commodity_name;

  const navigationPath =
    shouldShowType && baseAcres?.type_name
      ? `/arcplc/${crop_year}/${location_state_name}/${location_county_name}/${baseAcres.commodity_name}/${baseAcres.type_name}`
      : `/arcplc/${crop_year}/${location_state_name}/${location_county_name}/${baseAcres.commodity_name}`;

  return (
    <TilleyCard
      onClick={() => navigate(navigationPath)}
      Avatar={ArcPlcCropIcon}
      title={cardTitle}
      subtitle={""}
      customContent={
        <Stack direction="column" spacing={2} className="custom-content">
          <Stack direction="row" spacing={4} alignItems="center" justifyItems="center">
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{formatNumber(baseAcres?.base_acreage, 0)}</Typography>
              <Typography variant="overline">BASE ACRES</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{formatNumber(baseAcres?.plc_yield_weighted, 0)}</Typography>
              <Typography variant="overline">PLC YIELD</Typography>
            </Stack>
          </Stack>

          <Divider sx={{ margin: "0px !important" }} />

          {!isErrorArcPlc && (arcPlc?.arcPayment !== 0 || arcPlc?.plcPayment !== 0) && (
            <Stack direction="row" spacing={4} alignItems="center" justifyItems="center">
              <Stack direction="column" spacing={1}>
                <Typography variant="overline" className="payment-heading">
                  ARC-CO PAYMENT
                </Typography>
                <Typography variant="subtitle2">
                  {!isLoadingArcPlc && <>{formatPrice(arcPlc?.arcPayment, 0)}</>}
                  {isLoadingArcPlc && (
                    <>
                      <Skeleton />
                    </>
                  )}
                </Typography>
              </Stack>
              <Stack direction="column" spacing={1}>
                <Typography variant="overline" className="payment-heading">
                  PLC PAYMENT
                </Typography>
                <Typography variant="subtitle2">
                  {!isLoadingArcPlc && <>{formatPrice(arcPlc?.plcPayment, 0)}</>}
                  {isLoadingArcPlc && (
                    <>
                      <Skeleton />
                    </>
                  )}
                </Typography>
              </Stack>
            </Stack>
          )}

          {!isErrorArcPlc && arcPlc?.arcPayment === 0 && arcPlc?.plcPayment === 0 && (
            <Chip icon={<InfoIcon />} label="No payments projected" />
          )}

          {isErrorArcPlc && (
            <Chip className="warning" icon={<WarningIcon />} label="Unable to calculate ARC /PLC projections" />
          )}
        </Stack>
      }
      footer={""}
    />
  );
}
